function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { compose, defaultTo, isNil, toString } from 'ramda';
import { createSelector } from 'reselect';
import i18n from 'invision-core/src/components/i18n/i18n';
import Configurable from 'invision-core/src/components/configurable/configurable';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { CurrentCustomerSelector } from 'invision-core/src/components/customer/customer.selectors';
import { getBoolOrDefault } from 'invision-core/src/components/helpers/bool.helper';
import { BusinessUnitCustomTilesTemplateSelector } from 'invision-core/src/components/configurable/configurable.selectors';
import { CUSTOM_TILE_TYPE } from 'invision-core/src/constants/custom.tiles.constants';
import { CustomerAccountStatusViewIsViewable, CustomerTemplateSelector } from './customer.actions.template.selectors';
import { CustomerAccountStatusSelector } from './customer.account.status.selectors';
import { CustomTilesResultSelector } from './custom.tiles.selectors';
export var CustomerAccountStatusViewIsExpandedSelector = createSelector([CustomerAccountStatusViewIsViewable, CustomerTemplateSelector], function (hasAccountStatus, template) {
  if (hasAccountStatus && template && template.accountStatusWidget) {
    return template.accountStatusWidget.isExpanded;
  }
  return true;
});
export var CustomerAccountStatusViewHasTiles = createSelector([CustomerAccountStatusViewIsViewable, CustomerAccountStatusSelector, CustomerTemplateSelector], function (hasAccountStatus, accountStatus, template) {
  return Boolean(hasAccountStatus && accountStatus && template && template.accountStatusWidget && template.accountStatusWidget.tableData && template.accountStatusWidget.tableData.length);
});
export var CustomerAccountStatusViewNameSelector = createSelector([CustomerTemplateSelector], function (template) {
  return template && template.accountStatusWidget ? template.accountStatusWidget.Name : null;
});
var EXAMPLE_REQUEST = 'http://numbersapi.com/';
export var CustomerAccountStatusViewModelSelector = createSelector([CustomerAccountStatusViewIsViewable, CustomerAccountStatusSelector, CustomerTemplateSelector, CurrentCustomerSelector, BusinessUnitCustomTilesTemplateSelector, CustomTilesResultSelector], function (hasAccountStatus, accountStatus, template, currentCustomer, customTiles, customTilesResults) {
  if (hasAccountStatus) {
    if (accountStatus && template && template.accountStatusWidget && template.accountStatusWidget.tableData) {
      var tileList = [];
      template.accountStatusWidget.tableData.forEach(function (key) {
        var tile = Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS[key];
        if (tile) {
          tileList.push(Object.assign({}, tile, {
            glyph: for_account_status_tiles[key].glyph,
            isActionable: for_account_status_tiles[key].boolOrDefault(!!accountStatus[key], currentCustomer),
            isEmphasized: for_account_status_tiles[key].noEmphasis ? false : for_account_status_tiles[key].boolOrDefault(!!accountStatus[key], currentCustomer),
            name: i18n.translate(tile.label),
            value: for_account_status_tiles[key].defaultMethod(accountStatus[key], currentCustomer)
          }));
        } else {
          var customTileConfig = Object.values(customTiles).filter(function (tile) {
            return tile.Id === key;
          })[0];
          if (customTileConfig) {
            var isExample = customTileConfig.EndPoint.indexOf(EXAMPLE_REQUEST) > -1;
            var resultObj = customTilesResults && customTilesResults[key] ? customTilesResults[key] : {};
            var defaultMethod = customTileConfig.Type === CUSTOM_TILE_TYPE.NUMBER ? defaultToZero : customTileConfig.Type === CUSTOM_TILE_TYPE.BOOLEAN ? yesOrNo : textOrDash;
            tileList.push(Object.assign({}, customTileConfig, {
              glyph: 'custom-widget',
              hasError: Boolean(resultObj.hasError),
              isActionable: false,
              isCustom: true,
              isEmphasized: false,
              isExample: isExample,
              method: isExample ? 'get' : 'post',
              name: customTileConfig.Name,
              responseParam: isExample ? 'number' : 'value',
              value: defaultMethod(resultObj.value)
            }));
          }
        }
      });
      return tileList;
    }
  }
  return null;
});
export var textOrDash = function textOrDash(text) {
  return text ? text : '-';
};
export var defaultToZero = compose(toString, defaultTo(0));
export var yesOrNo = function yesOrNo(bool) {
  return bool ? i18n.translate(CoreLocaleKeys.YES) : i18n.translate(CoreLocaleKeys.NO);
};
export var yesOrNoForLoginRevoked = function yesOrNoForLoginRevoked(bool, currentCustomer) {
  if (isNil(currentCustomer)) {
    return yesOrNo(bool);
  } else {
    return currentCustomer.LoginRevoked ? i18n.translate(CoreLocaleKeys.YES) : i18n.translate(CoreLocaleKeys.NO);
  }
};
export var boolOrDefault = function boolOrDefault(bool) {
  return getBoolOrDefault(bool);
};
export var boolOrDefaultForLoginRevoked = function boolOrDefaultForLoginRevoked(bool, currentCustomer) {
  if (isNil(currentCustomer)) {
    return boolOrDefault(bool);
  } else {
    return currentCustomer.LoginRevoked;
  }
};
var for_account_status_tiles = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.DISCRETIONARY_DISCOUNTS_COUNT, {
  glyph: 'percent',
  defaultMethod: defaultToZero,
  boolOrDefault: boolOrDefault
}), Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.DEVICE_SESSION_PIN_BOOL, {
  glyph: 'devices',
  noEmphasis: true,
  defaultMethod: yesOrNo,
  boolOrDefault: boolOrDefault
}), Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.EXPIRED_PI_COUNT, {
  glyph: 'credit-card-no-f',
  defaultMethod: defaultToZero,
  boolOrDefault: boolOrDefault
}), Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.LOGIN_REVOKED_BOOL, {
  glyph: 'user',
  defaultMethod: yesOrNoForLoginRevoked,
  boolOrDefault: boolOrDefaultForLoginRevoked
}), Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.OPEN_CASES_COUNT, {
  glyph: 'briefcase',
  defaultMethod: defaultToZero,
  boolOrDefault: boolOrDefault
}), Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.OPEN_ORDERS_COUNT, {
  glyph: 'shopping-cart',
  defaultMethod: defaultToZero,
  boolOrDefault: boolOrDefault
}), Configurable.CustomerCare.CUSTOMER_ACCOUNT_STATUS_CONSTANTS_IDS.PAYMENT_FAILURES_COUNT, {
  glyph: 'credit-card-alt',
  defaultMethod: defaultToZero,
  boolOrDefault: boolOrDefault
});